export default (state = {}, action) => {
  switch (action.type) {
    case 'LOGIN':
      return {
        ...state,
        token: action.token,
        username: action.username,
        firstName: action.firstName,
        lastName: action.lastName,
        email: action.email,
        avatar: action.avatar,
        role: action.role,
        userId: action.userId,
        pageId: action.pageId,
        employeeId: action.employeeId
      };
    case 'LOGOUT':
      return {};
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/authReducer.jsx